import { useAppSelector } from './useAppSelector';

const useFormCampaignId = () => {
  const campaignId = useAppSelector(state => state.form?.campaignId);

  return campaignId;
};

export default useFormCampaignId;
